export const DUMMY_MUTATION = 'DUMMY_MUTATION';

export const CORDOVA_DEVICEREADY = 'CORDOVA_DEVICEREADY';
export const CORDOVA_ONLINE = 'CORDOVA_ONLINE';
export const CORDOVA_OFFLINE = 'CORDOVA_OFFLINE';
export const CORDOVA_SET_DEVICE = 'CORDOVA_SET_DEVICE';
export const CORDOVA_SET_VERSION = 'CORDOVA_SET_VERSION';
export const CORDOVA_DEVICE_REGISTER = 'CORDOVA_DEVICE_REGISTER';
export const CORDOVA_DEVICE_UPDATED = 'CORDOVA_DEVICE_UPDATED';
export const CORDOVA_NEW_NOTIFICATION = 'CORDOVA_NEW_NOTIFICATION';

export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const AUTH_SET_USER = 'AUTH_SET_USER';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_FIRST_TIME = 'AUTH_FIRST_TIME';

export const TRIP_STATE = {
    ARRIVED_TO_DESTINATION: 'arrived_to_destination',
    ARRIVED_TO_ORIGIN: 'arrived_to_origin',
    ACCEPTED: 'accepted',
    RIDEUP: 'rideup',
    CANCELED_BY_USER: 'canceled_by_user',
    CANCELED_BY_PASSENGER: 'canceled_by_passenger',
    CANCELED_BY_DRIVER: 'canceled_by_driver',
    FINISH: 'finish',
    ACCEPTED_REFUSED: 'accepted_refused',
    PENDING: 'pending',
    TIMEOUT: 'timeout'
};

export const BACKEND_TRIP_STATE = {
    PENDIENTE: 0,
    ACEPTADO: 1,
    ABORDADO: 2,
    RECHAZADO: 3,
    FINALIZADO: 4,
    CANCELADO: 5
};



// WEBPACK FOOTER //
// ./src/store/mutation-types.js